"use client";
import t from "styled-components";
const o = t.div`
  display: flex;
  gap: 0.5rem;
`;
export {
  o as default
};
//# sourceMappingURL=index.es82.js.map
